import { useEffect, useState } from "react";
import shopify from "../js/shopify";
import { lazyComponents } from "@src/utilities/LazyComponent";
import SideMenu from "@src/stories/navigation/Header/SideHeaderMenu/SideHeaderMenu";
import StableHeightContainer from "./StableHeightContainer";

StyleWithComponent.displayName = 'theme__lm-stylewith';
export function StyleWithComponent({ ...props }) {
    const StyleWith = lazyComponents['StyleWith'];

    const [ products, setProducts] = useState([]);
    const [ styleProducts, setStyleProducts] = useState([]);
    const [ loadedProducts, setLoadedProducts] = useState(false);
    const { product,product_id } = props.settings;
    const { product_ids } = props.settings;

    useEffect(() => {
        if (product_ids && product_ids.length > 0) {
            async function fetchProducts(productIds) {
                const validProductIds = productIds.filter(id => id); // Ensure no null or empty IDs
                if (validProductIds.length > 0) {
                    const products = await shopify.getShopifyProductList(validProductIds);
                    setLoadedProducts(true);
                    setStyleProducts(products);
                }
            }

            fetchProducts(product_ids);
        }

        async function fetchProductRecommendations(productId) {
            // console.log(`Fetching recommended products for: ${productId}`);
            const recommendedProducts = await shopify.getRecommendedProducts(productId);
            setLoadedProducts(true);
            setProducts(recommendedProducts);
        }

        if (product?.id || product_id) {
            fetchProductRecommendations(product.id || product_id);
        }
    }, [product_ids]);

    if (!loadedProducts){
        return null;
    }

    return (
        <StyleWith
            products={products}
            settings={props.settings}
            style_products={styleProducts}
        />
    );
}

CurrencySelectorComponent.displayName = 'theme__currency-selector';
export function CurrencySelectorComponent({ ...props }) {
    const CurrencySelector = lazyComponents['CurrencySelector'];
    return (
        <CurrencySelector settings={props} />
    );
}

OutOfStockComponent.displayName = 'theme__client_outofstock';
export function OutOfStockComponent({ ...props }) {
    const BackInStock = lazyComponents['BackInStock'];
    return (
        <BackInStock settings={props} />
    );
}

FindInStoreComponent.displayName = 'theme__client_findinstore';
export function FindInStoreComponent({ ...props }) {
    const FindInStore = lazyComponents['FindInStore'];
    return (
        <FindInStore settings={props} />
    );
}

ProjectShowcaseComponent.displayName = 'theme__client_projectshowcase';
export function ProjectShowcaseComponent({ ...props }) {
    const ProjectShowcase = lazyComponents['ProjectShowcase'];
    
    return (
        <ProjectShowcase settings={props}/>
    );
}

ProjectShowcaseSplideComponent.displayName = 'theme__client_projectshowcase_splide';
export function ProjectShowcaseSplideComponent({ ...props }) {
    const ProjectShowcaseSplide = lazyComponents['ProjectShowcaseSplide'];

    return (
        <ProjectShowcaseSplide settings={props}/>
    );
}

ExpertiseBlockComponent.displayName = 'theme__client_expertise';
export function ExpertiseBlockComponent({ ...props }) {
    const ExpertiseBlock = lazyComponents['ExpertiseBlock'];

    return (
        <ExpertiseBlock settings={props}/>
    );
}

BlogBarComponent.displayName = 'theme__blog_bar';
export function BlogBarComponent({ ...props }) {
    const BlogBar = lazyComponents['BlogBar'];

    return (
        <StableHeightContainer id={`banner-${props.settings.section_id}`} targetParent={true} parentSelector=".shopify-section">
        <BlogBar settings={props}/>
        </StableHeightContainer>
    );
}

BlogFooterComponent.displayName = 'theme__blog_footer';
export function BlogFooterComponent({ ...props }) {
    const BlogFooter = lazyComponents['BlogFooter'];

    return (
        <StableHeightContainer id={`banner-${props.settings.section_id}`} targetParent={true} parentSelector=".shopify-section">
        <BlogFooter settings={props}/>
        </StableHeightContainer>
    );
}

ServicesRippleComponent.displayName = 'theme__client_services';
export function ServicesRippleComponent({ ...props }) {
    const ServicesRipple = lazyComponents['ServicesRipple'];

    return (
        <ServicesRipple settings={props}/>
    );
}

ShopifyLandingComponent.displayName = 'theme__client_shopify_landing';
export function ShopifyLandingComponent({ ...props }) {
    const ShopifyLanding = lazyComponents['ShopifyLanding'];

    return (
        <ShopifyLanding settings={props}/>
    );
}

AwardsComponent.displayName = 'theme__client_awards';
export function AwardsComponent({ ...props }) {
    const Awards = lazyComponents['Awards'];

    return (
        <Awards settings={props}/>
    );
}

CaseStudiesComponent.displayName = 'theme__client_casestudies';
export function CaseStudiesComponent({ ...props }) {
    const CaseStudies = lazyComponents['CaseStudies'];

    return (
        <CaseStudies settings={props}/>

    );
}

TelcosComponent.displayName = 'theme__client_telcos';
export function TelcosComponent({ ...props }) {
    const Telcos = lazyComponents['Telcos'];

    return (
        <Telcos settings={props}/>
    );
}

TelcoListingHeroComponent.displayName = 'theme__telco_listing_hero';
export function TelcoListingHeroComponent({ ...props }) {
    const TelcoListingHero = lazyComponents['TelcoListingHero'];
    return (
        <TelcoListingHero settings={props}/>
    );
}

TelcoOurSolutionsComponent.displayName = 'theme__client_telco_our_solutions';
export function TelcoOurSolutionsComponent({ ...props }) {
    const TelcoOurSolutions = lazyComponents['TelcoOurSolutions'];

    return (
        <TelcoOurSolutions settings={props}/>
    );
}

TelcoFaqsComponent.displayName = 'theme__client_telco_faqs';
export function TelcoFaqsComponent({ ...props }) {
    const TelcoFaqs = lazyComponents['TelcoFaqs'];

    return (
        <TelcoFaqs settings={props}/>
    );
}

TelcoRecommendedComponent.displayName = 'theme__telco_recommended';
export function TelcoRecommendedComponent({ ...props }) {
    const TelcoRecommended = lazyComponents['TelcoRecommended'];
    return (
        <TelcoRecommended settings={props}/>
    );
}

TransformTimelineComponent.displayName = 'theme__client_transformtimeline';
export function TransformTimelineComponent({ ...props }) {
    const TransformTimeline = lazyComponents['EnhancedTransformTimeline'];

    return (
       
        <TransformTimeline settings={props} />
  
    );
}

ShopifyMigrationComponent.displayName = 'theme__client_shopifymigration';
export function ShopifyMigrationComponent({ ...props }) {
    const ShopifyMigration = lazyComponents['ShopifyMigration'];

    return (
        <ShopifyMigration settings={props} />
    );
}

SideHeaderComponent.displayName = 'theme__navigation-side-header';
export function SideHeaderComponent({ ...props }) {
    const SideHeaderMenu = lazyComponents['SideHeaderMenu'];

    return (
        <SideHeaderMenu settings={props} />
    );
}

ShopifyFeaturesComponent.displayName = 'theme__shopify_features';
export function ShopifyFeaturesComponent({ ...props }) {
    const ShopifyFeatures = lazyComponents['ShopifyFeatures'];

    return (
        <ShopifyFeatures settings={props}/>
    );
}

ShopifyMigrationClients.displayName = 'theme__shopify-migration-clients';
export function ShopifyMigrationClients({ ...props }) {
  const ClientsComponent = lazyComponents['ShopifyMigrationClients'];
  return <ClientsComponent settings={props} />;
}

ShopifyTCOComponent.displayName = 'theme__shopify-tco';
export function ShopifyTCOComponent({ ...props }) {
  const ShopifyTCO = lazyComponents['ShopifyTCO'];
  return <ShopifyTCO settings={props} />;
}

CircleTextSection.displayName = 'theme__circle-text-section';
export function CircleTextSection({ ...props }) {
  const CircleTextSection = lazyComponents['CircleTextSection'];
  return <CircleTextSection props={props} />;
}

CaseStudyResults.displayName = 'theme__client_casestudy_results';
export function CaseStudyResults({ ...props }) {
  const CaseStudyResults = lazyComponents['CaseStudyResults'];
  return <CaseStudyResults settings={props} />;
}

Foundations.displayName = 'theme__client_foundations';
export function Foundations({ ...props }) {
  const Foundations = lazyComponents['Foundations'];
  return <Foundations settings={props} />;
}

SectionServicesSticky.displayName = 'theme__services-sticky';
export function SectionServicesSticky({ ...props }) {
  const { settings } = props;

  const ServicesStickyComponent = lazyComponents['ServicesSticky'];
 
  return <ServicesStickyComponent settings={settings} />;
}

ScrollDownArrow.displayName = 'theme__scroll-down-arrow';
export function ScrollDownArrow({ ...props }) {
  const { settings } = props;

  const ScrollDownArrow = lazyComponents['ScrollDownArrow'];

  return <ScrollDownArrow settings={settings} />;
}
